import { render, staticRenderFns } from "./Sociedades.vue?vue&type=template&id=0b8aa49f"
import script from "./Sociedades.vue?vue&type=script&lang=js"
export * from "./Sociedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports